<template>
<div>
    <div class="card" :class="night ? 'bg-dark-gray' : ''">
        <div class="card-body">
            <div class="row mb-3">
                <div class="col">
                    <button v-if="providerPermisos.create.status" class="btn btn-primary btn-rounded btn-sm d-none d-md-block" @click="create">
                        <i class="fas fa-plus fa-lg me-2"></i>
                        <span class="d-md-inline d-none">Nuevo proveedor</span>
                    </button>
                    <button v-if="providerPermisos.create.status" class="btn btn-primary btn-floating d-block d-md-none" @click="create">
                        <i class="fas fa-plus fa-lg"></i>
                    </button>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-8 d-inline d-md-none">
                    <div class="input-group input-group-sm rounded ms-auto">
                        <input type="search" v-model="search" class="form-control rounded" placeholder="Buscar" aria-label="Search" aria-describedby="search-addon" />
                        <span class="input-group-text border-0" id="search-addon">
                            <i class="fas fa-search" :class="night ? 'text-white' : ''"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="d-xl-flex d-lg-flex d-md-flex align-items-center mb-3">
                <div class="input-group input-group-sm rounded me-2 d-none d-md-inline-flex" style="width: 175px;">
                    <span class="input-group-text border-0" :class="night ? 'text-white' : ''">Filas por página: </span>
                    <select v-model="itemperpage" class="form-select form-select-sm rounded">
                        <option value="10" selected>10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                    </select>
                </div>
                <div class="me-auto ms-2 mb-xl-0 mb-lg-0 mb-2 d-none d-md-inline">
                    <small>Mostrando {{ pagination.from }}-{{ pagination.to }} de {{ pagination.total }}</small>
                </div>
                <div class="ms-auto mb-xl-0 mb-lg-0 mb-2">
                    <nav class="d-flex">
                        <ul class="pagination pagination-circle pagination-sm mb-0 ms-auto me-auto">
                            <li class="page-item" v-if="pagination.current_page > 1" @click.prevent="changePageActivosData(pagination.current_page - 1)">
                                <a class="page-link" :class="night ? 'w3-text-white w3-hover-white' : ''" href="#" tabindex="-1" aria-disabled="true">Anterior</a>
                            </li>
                            <li class="page-item" style="z-index: 1;" v-for="(page, index) in pagesNumberActivosData" :key="index" :class="[page == isActivedActivosData ? 'active' : '']" @click.prevent="changePageActivosData(page)">
                                <a class="page-link" :class="night && page != isActivedActivosData ? 'w3-text-white w3-hover-white' : ''" href="#">{{ page }}</a>
                            </li>
                            <li class="page-item" v-if="pagination.current_page < pagination.last_page" @click.prevent="changePageActivosData(pagination.current_page + 1)">
                                <a class="page-link" :class="night ? 'w3-text-white w3-hover-white' : ''" href="#">Siguiente</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div class="table-responsive overflow-auto d-none d-md-block" :style="'height:' + heightsize + 'px;'">
                <table class="table table-hover table-sm align-middle" :class="night ? 'table-dark' : 'table-light'" :style="'width:' + widthsize + 'px;'">
                    <thead style="position: sticky;top: 0;" :class="night ? 'w3-dark-gray' : 'w3-light-gray'">
                        <tr class="text-center" :class="night ? 'border-dark' : 'border'" style="position: sticky;top: 0;">
                            <th class="fw-bold" :class="night ? 'w3-dark-gray' : 'w3-light-gray'" style="position: sticky;left: 0;width: 10px;z-index: 1;">
                                <label class="mb-1">Opciones</label>
                                <button v-if="filters" class="btn btn-outline-black btn-rounded btn-sm" :class="night ? 'w3-white' : ''" @click="cleanFilters">
                                    <i class="fas fa-eraser fa-lg"></i>
                                </button>
                            </th>
                            <th class="fw-bold" style="position: sticky;top: 0;">
                                <label class="mb-1">Nombre comercial</label>
                                <input v-model="comercialName" type="search" class="form-control form-control-sm" placeholder="Buscar">
                            </th>
                            <th class="fw-bold" style="position: sticky;top: 0;">
                                <label class="mb-1">Razón social</label>
                                <input v-model="razonSocial" type="search" class="form-control form-control-sm" placeholder="Buscar">
                            </th>
                            <th class="fw-bold" style="position: sticky;top: 0;">
                                <label class="mb-1">Correo</label>
                                <input v-model="email" type="search" class="form-control form-control-sm" placeholder="Buscar">
                            </th>
                            <th class="fw-bold" style="position: sticky;top: 0;">
                                <label class="mb-1">Dirección</label>
                                <input v-model="address" type="search" class="form-control form-control-sm" placeholder="Buscar">
                            </th>
                            <th class="fw-bold" style="position: sticky;top: 0;">
                                <label class="mb-1">Teléfono</label>
                                <input v-model="phone" type="search" class="form-control form-control-sm" placeholder="Buscar">
                            </th>
                            <th class="fw-bold" style="position: sticky;top: 0;">
                                <label class="mb-1">Factura</label>
                                <select v-model="factura" class="form-select form-select-sm">
                                    <option value="">Todos</option>
                                    <option value="1">Sí realiza factura</option>
                                    <option value="0">No realiza factura</option>
                                </select>
                            </th>
                            <th class="fw-bold" style="position: sticky;top: 0;">
                                <label class="mb-1">Tipo de pago</label>
                                <select v-model="payType" class="form-select form-select-sm">
                                    <option value="">Todos</option>
                                    <option value="1">Transferencia o cheque</option>
                                    <option value="0">Tarjeta o efectivo</option>
                                </select>
                            </th>
                            <th class="fw-bold" style="position: sticky;top: 0;">
                                <label class="mb-1">Creación</label>
                                <input v-model="creacion" type="Date" class="form-control form-control-sm" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" placeholder="Buscar">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="load">
                            <td colspan="10" class="text-center">
                                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </td>
                        </tr>
                        <tr v-else class="text-center" v-for="(item, index) in proveedores" :key="index">
                            <td :class="night ? 'w3-dark-gray' : 'w3-light-gray'" style="position:sticky;left:0px;">
                                <div class="btn-group btn-group-sm" role="group">
                                    <button v-if="providerPermisos.edit.status" type="button" class="btn btn-warning" @click="edit(item)">
                                        <i class="fas fa-pencil-alt fa-lg"></i>
                                    </button>
                                    <button v-if="providerPermisos.delete.status" type="button" class="btn btn-danger" @click="destroy(item)">
                                        <i class="fas fa-trash-alt fa-lg"></i>
                                    </button>
                                </div>
                            </td>
                            <td @click="show(item)">{{ item.comercialname }}</td>
                            <td @click="show(item)">{{ item.razonsocial }}</td>
                            <td @click="show(item)">{{ item.email }}</td>
                            <td @click="show(item)">{{ item.address }}</td>
                            <td @click="show(item)">{{ item.phone }}</td>
                            <td v-if="item.factura === 1" @click="show(item)">Si realiza factura</td>
                            <td v-else @click="show(item)">No realiza factura</td>
                            <td v-if="item.payType == 1" @click="show(item)">Transferencia o cheque</td>
                            <td v-else @click="show(item)">Tarjeta o efectivo</td>
                            <td @click="show(item)">{{ getMomentDate(item.created_at) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ul class="list-group overflow-auto d-block d-md-none border-top border-5" :style="'height:' + heightsize + 'px;'">
                <li v-if="load" class="list-group-item text-center" :class="night ? 'w3-dark-gray' : 'w3-white'">
                    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </li>
                <li v-else v-for="(item, index) in proveedores" :key="'sm' + index" class="list-group-item" :class="night ? 'w3-dark-gray' : 'w3-white'">
                    <div class="row mb-3">
                        <div class="col-6">
                            <strong>#</strong>
                            <small>{{ index + 1 }}</small>
                        </div>
                        <div class="col-6 text-end">
                            <div class="btn-group btn-group-sm" role="group">
                                <button type="button" class="btn btn-warning" @click="edit(item)">
                                    <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>
                                <button type="button" class="btn btn-danger" @click="destroy(item)">
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center" @click="show(item)">
                        <small class="fw-bold me-2">Nombre comercial:</small>
                        <small>{{ item.comercialname }}</small>
                    </div>
                    <div class="d-flex align-items-center" @click="show(item)">
                        <small class="fw-bold me-2">Razón social:</small>
                        <small>{{ item.razonsocial }}</small>
                    </div>
                    <div class="d-flex align-items-center" @click="show(item)">
                        <small class="fw-bold me-2">Correo:</small>
                        <small>{{ item.email }}</small>
                    </div>
                    <div class="d-flex align-items-center" @click="show(item)">
                        <small class="fw-bold me-2">Dirección:</small>
                        <small>{{ item.address }}</small>
                    </div>
                    <div class="d-flex align-items-center" @click="show(item)">
                        <small class="fw-bold me-2">Teléfono:</small>
                        <small>{{ item.phone }}</small>
                    </div>
                    <div class="d-flex align-items-center" @click="show(item)">
                        <small class="fw-bold me-2">Factura:</small>
                        <small v-if="item.factura === 1">Sí</small>
                        <small v-else>No</small>
                    </div>
                    <div class="d-flex align-items-center" @click="show(item)">
                        <small class="fw-bold me-2">Tipo de pago:</small>
                        <small v-if="item.payType == 1">Transferencia o cheque</small>
                        <small v-else>Tarjeta o efectivo</small>
                    </div>
                    <div class="d-flex align-items-center" @click="show(item)">
                        <small class="fw-bold me-2">Creación:</small>
                        <small>{{ getMomentDate(item.created_at) }}</small>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <router-view></router-view>
</div>
</template>

<script>
import $axios from 'axios'
import $swal from 'sweetalert2'
import moment from 'moment'
export default {
    props: {
        $permisos: Object,
    },
    created() {
        this.darkmode();
        this.providerPermisos = this.$permisos.admin.permisos;
        this.productsPermisos = this.$permisos.products.permisos;
        this.changeSize();
        this.getProveedores();
        moment.locale('es-mx');
        this.debounceGetProveedores = _.debounce(this.getProveedores, 500);
    },
    watch: {
        search() {
            this.debounceGetProveedores();
        },
        comercialName() {
            this.debounceGetProveedores();
        },
        razonSocial() {
            this.debounceGetProveedores();
        },
        email() {
            this.debounceGetProveedores();
        },
        address() {
            this.debounceGetProveedores();
        },
        phone() {
            this.debounceGetProveedores();
        },
        factura() {
            this.getProveedores();
        },
        payType() {
            this.getProveedores();
        },
        creacion() {
            this.getProveedores();
        },
        itemperpage() {
            this.getProveedores();
        }
    },
    data() {
        return {
            night: null,
            proveedores: [],
            pagination: {},
            providerPermisos: {},
            productsPermisos: {},
            search: '',
            comercialName: '',
            razonSocial: '',
            email: '',
            address: '',
            phone: '',
            factura: '',
            payType: '',
            creacion: '',
            itemperpage: 10,
            offset: 6,
            widthsize: null,
            heightsize: null,
            load: false,
        }
    },
    mounted() {
        window.Echo.channel('channel-darkmode').listen('DarkModeChangeEvent', (e) => {
            this.darkmode();
        });
        window.addEventListener("resize", this.changeSize);
    },
    methods: {
        darkmode() {
            if (localStorage.nightMode == 'true') {
                this.night = true;
            }
            if (localStorage.nightMode == 'false') {
                this.night = false;
            }
        },
        getProveedores(page) {
            this.load = true;
            let searchData = {
                search: this.search,
                comercialname: this.comercialName,
                razonsocial: this.razonSocial,
                email: this.email,
                address: this.address,
                phone: this.phone,
                factura: this.factura,
                paytype: this.payType,
                creacion: this.creacion,
                itemperpage: this.itemperpage,
            }
            $axios.get(this.$masterRoute + '/api/proveedores?page=' + page + '&searchdata=' + JSON.stringify(searchData), {
                headers: {
                    Authorization: 'Bearer ' + JSON.parse(sessionStorage.authToken)
                }
            }).then(response => {
                this.proveedores = response.data.proveedores.data;
                this.pagination = response.data.pagination;
                this.load = false;
            }).catch(error => {
                console.error(error);
                if (error.response.status === 401) {
                    $swal.fire({
                        icon: 'error',
                        title: 'Sesión expirada',
                        text: 'No tiene autorizado continuar en el sistema, inicie sesion!!',
                    }).then((result) => {
                        this.$router.push({
                            name: 'login'
                        });
                    });
                } else {
                    $swal.fire({
                        icon: 'error',
                        title: 'Error Inesperado!!',
                        text: 'El sistema obtuvo un error inesperado, por favor comunicate con soporte para solucionarlo',
                    });
                }
                this.load = false;
            });
        },
        show(item) {
            this.$router.push({
                name: 'indexProductos',
                params: {
                    p_prov: item,
                    p_permisos: this.productsPermisos,
                }
            });
        },
        create() {
            this.$router.push({
                name: 'createProveedor',
                params: {
                    p_reload: this.getProveedores,
                }
            });
        },
        edit(item) {
            this.$router.push({
                name: 'editProveedor',
                params: {
                    p_item: item,
                    p_reload: this.getProveedores,
                }
            })
        },
        destroy(item) {
            $swal.fire({
                title: '¿Estás seguro?',
                text: "Estás a punto de eliminar un proveedor!!",
                icon: 'warning',   
                background: '#474747',
                showCancelButton: true,
                confirmButtonColor: '#03cc9a',
                cancelButtonColor: '#ED1848',
                confirmButtonText: 'Si, eliminarlo!',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.load = true;
                    $axios.delete(this.$masterRoute + '/api/proveedores/' + item.id, {
                        headers: {
                            Authorization: 'Bearer ' + JSON.parse(sessionStorage.authToken)
                        }
                    }).then(response => {
                        if (response.data.status) {
                            $swal.fire({
                                icon: 'success',
                                title: response.data.title,
                                text: response.data.menssage,
                            });
                            this.getProveedores();
                        } else {
                            $swal.fire({
                                icon: 'error',
                                title: response.data.title,
                                text: response.data.menssage,
                            });
                        }
                        this.load = false;
                    }).catch(error => {
                        console.error(error);
                        if (error.response.status === 401) {
                            $swal.fire({
                                icon: 'error',
                                title: 'Sesión expirada',
                                text: 'No tiene autorizado continuar en el sistema, inicie sesion!!',
                            }).then((result) => {
                                this.$router.push({
                                    name: 'login'
                                });
                            });
                        } else {
                            $swal.fire({
                                icon: 'error',
                                title: 'Error Inesperado!!',
                                text: 'El sistema obtuvo un error inesperado, por favor comunicate con soporte para solucionarlo',
                            });
                        }
                        this.load = false;
                    });
                }
            });
        },
        getMomentDate(date) {
            return moment(date).format('LLLL');
        },
        changeSize() {
            if (window.innerWidth > 2000) {
                this.widthsize = window.innerWidth;
            } else {
                this.widthsize = 2000;
            }
            if (window.innerWidth < 576) {
                this.heightsize = window.innerHeight - 225;
            } else {
                this.heightsize = window.innerHeight - 240;
            }
        },
        cleanFilters() {
            this.comercialName = '';
            this.razonSocial = '';
            this.email = '';
            this.address = '';
            this.phone = '';
            this.factura = '';
            this.payType = '';
            this.creacion = '';
        },
        changePageActivosData(page) {
            this.load = true;
            this.pagination.current_page = page;
            this.getProveedores(page);
        },
    },
    computed: {
        isActivedActivosData: function () {
            return this.pagination.current_page;
        },
        pagesNumberActivosData: function () {
            if (!this.pagination.to) {
                return [];
            }

            var from = this.pagination.current_page - (this.offset / 2);
            if (from < 1) {
                from = 1;
            }

            var to = from + (this.offset);
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }

            var pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
        filters() {
            if (!this.comercialName && !this.razonSocial && !this.email && !this.address && !this.phone && !this.factura && !this.payType && !this.creacion) {
                return false;
            }
            return true;
        },
    }
}
</script>
